import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import {
  AppContainer,
  Workspace,
  NotFound,
  RouteInfo,
  createRoutes,
  PrivateRoute,
  addMenuTopAreaItem,
  storage,
  notification,
} from '@digital/ui';
import models, { useStore, useActions } from '@app/store/models';
import Logo from '../public/images/logo_mrn_verde.svg';
// import Logo from '../public/images/logo-mrn-header.png';
import menu from './config/menu.json';
import app from './config/app.json';
import { getExpirationTime, getJwt, getLoggedUsername } from './helpers';
import { getPermissions } from './api/account';
import { setAuthorizationToken } from './api/api';
import { RecoilRoot } from 'recoil';

import {
  Usuario,
  Contrato,
  Diretoria,
  Area,
  Login,
  Departamento,
  AcronimoProjeto,
  AcronimoPacote,
  PlanilhaCapex,
  PlanilhaRfa,
  Projeto,
  CicloOrcamentario,
  PlanilhaOrcadoEconomicoAnoMes,
  ContratosEspeciais,
  ContratadoPcs,
  ConfiguracaoComponent,
  ContratadoPcm,
  ContratadoSemVinculoOi,
  RequisitadoOc,
  RequisitadoRc,
  Executado,
  RelatorioCicloOrcamentario,
  RelatorioCicloOrcamentarioProjeto,
  RelatorioCicloOrcamentarioPluriAnual,
  RelatorioCicloOrcamentarioProjetoPluriAnual,
  ExecutiveSummary,
  CurvaEconomica,
  Buildup,
  DefinicaoProjeto,
  DefinicaoFornecedor,
  Programa,
  RelatorioPacote,
  RelatorioOi,
  RelatorioProjetoCicloAnoPluriAnual,
  Dolar,
  Home,
  Fechamento,
  DetalheProjetoFechamento,
  RotinaFechamento,
  PerfilAcesso,
  ModuloPerfilPermissao,
  DefinicaoPermissao,
  DefinicaoTipoModulo,
  CadastroPermissao,
  MeusDados,
  ManutencaoPcmFornecedor,
  ProjectsOverview,
  RelatorioProjectsOverview,
  DetalheFechamentoProjetoOverView,
  ProjetosADistribuir,
  UsuarioUltimoAcesso,
  AreaExecutiveSummary,
  CRFAcronimoAgrupador,
  CRFAcronimoProjeto,
  CrfCicloOrcamentarioComponent,
  CrfContratosEspeciais,
  CrfDefinicaoProjeto,
  CrfPrograma,
  LogContratadoAno,
  CrfContaContabilAgrupador,
  CrfRotinaFechamento,
  CrfVerificacaoDeErros,
  CrfParametros,
  CrfTermoDeAbertura,
  CrfPlanilhaCapex,
  CrfRequisitadoOc,
  CrfRequisitadoRc,
  CrfPlanilhaRfa,
  CrfEsin204ContaResultado,
  CrfPlanilhaOrcadoEconomicoAnoMes,
  CrfEsin204FechamentoMina,
  PedidoMaterialIndex,
  PedidoServicoIndex,
  PedidoSemVinculoCrIndex,
  ListaAgrupadores,
  CrfExecutiveSummary,
  CrfCurvaEconomica,
  CrfBuildup,
  CrfRelatorioProjectsOverview,
  CrfAreaExecutiveSummary,
  CrfRelatorioCicloOrcamentario,
  CrfRelatorioCicloOrcamentarioProjeto,
  CrfRelatorioCicloOrcamentarioProjetoPluriAnual,
  CrfRelatorioCicloOrcamentarioPluriAnual,
  CrfFechamento,
  CrfRelatorioProjetoCicloAnoPluriAnual,
  CrfDetalheProjetoFechamento,
  CrfDetalheFechamentoProjetoOverView,
  NaoPrevistoParametrosCadastroTipo,
  NaoPrevistoParametrosCadastroOrcadoAno,
  NaoPrevistoListaSolicitacao,
  NaoPrevistoSolicitacao,
  NaoPrevistoCadastroParametrosAprovacao,
  AprovadorAlternativo,
  CaixaEntrada,
  NaoPrevistoControle
} from './views';
import { registarLogout } from './api/usuario';
import ExternalRedirect from './views/ExternalRedirect';
import { isNotEmpty } from './helpers/string';
import ServicoPrazosComponent from './views/Servico/Prazos';
import DiretoriaEstatutaria from './views/NaoPrevistos/DiretoriaEstatutaria';
import AuthProvider from './providers/AuthProvider';
import { msalInstance } from './config/msalConfig';
import { useMsal } from '@azure/msal-react';



const routes: RouteInfo[] = [

  //#region Nao Previsto

  { path: '/naoPrevisto/parametros/cadastroMotivador', component: NaoPrevistoParametrosCadastroTipo, permissions: ['NAO_PREVISTO_PARAMETROS_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/parametros/cadastroOrcadoAno', component: NaoPrevistoParametrosCadastroOrcadoAno, permissions: ['NAO_PREVISTO_PARAMETROS_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/parametros/cadastroParametrosAprovacao', component: NaoPrevistoCadastroParametrosAprovacao, permissions: ['NAO_PREVISTO_PARAMETROS_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/solicitacoes', component: NaoPrevistoListaSolicitacao, permissions: ['NAO_PREVISTO_SOLICITACAO_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/solicitacao/new', component: NaoPrevistoSolicitacao, permissions: ['NAO_PREVISTO_SOLICITACAO_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/solicitacao/:id', component: NaoPrevistoSolicitacao, permissions: ['NAO_PREVISTO_SOLICITACAO_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/aprovadorAlternativo', component: AprovadorAlternativo, permissions: ['NAO_PREVISTO_APROVADOR_ALTERNATIVO_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/diretoriaEstatutaria', component: DiretoriaEstatutaria, permissions: ['NAO_PREVISTO_APROVADOR_ALTERNATIVO_VISUALIZAR_MENU'] },
  { path: '/naoPrevisto/caixaEntrada', component: CaixaEntrada },
  { path: '/naoPrevisto/controle', component: NaoPrevistoControle },

  //#endregion

  //#region CRF
  //#region Cadastros Basicos
  { path: '/CrFch/cicloOrcamentario', component: CrfCicloOrcamentarioComponent, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/CrFch/acronimoAgrupado', component: CRFAcronimoAgrupador, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU',] },
  { path: '/CrFch/acronimoDeprojeto', component: CRFAcronimoProjeto, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU',] },
  { path: '/CrFch/contratosEspeciais', component: CrfContratosEspeciais, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/CrFch/definificaoDosProjeto', component: CrfDefinicaoProjeto, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/CrFch/cadastroDeProgramas', component: CrfPrograma, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/CrFch/contaContabilAgrupador', component: CrfContaContabilAgrupador, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/CrFch/rotinas', component: CrfRotinaFechamento, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/CrFch/verificacaoDeErro', component: CrfVerificacaoDeErros, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/CrFch/parametros', component: CrfParametros, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/listaCentroCustoContaContabil', component: ListaAgrupadores, permissions: ['MODULO_RELATORIOS_OIS_VISUALIZAR_MENU_FECHAMENTO_MINA_E_CONTA_RESULTADO'] },
  //#endregion

  //#region Modulo CR
  { path: '/Cr/termoDeAbertura', component: CrfTermoDeAbertura, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/Cr/moduloOrcado/capex', component: CrfPlanilhaCapex, permissions: ['MODULO_ORCADO_VISUALIZAR_MENU'], },
  { path: '/Cr/moduloOrcado/rfa', component: CrfPlanilhaRfa, permissions: ['MODULO_ORCADO_VISUALIZAR_MENU'], },
  { path: '/Cr/moduloOrcado/economicoAnoMes', component: CrfPlanilhaOrcadoEconomicoAnoMes, permissions: ['MODULO_ORCADO_VISUALIZAR_MENU'], },
  { path: '/Cr/moduloRequisitado/requisicaoCompra', component: CrfRequisitadoRc, permissions: ['MODULO_REQUISITADO_VISUALIZAR_MENU'] },
  { path: '/Cr/moduloRequisitado/ordemCompra', component: CrfRequisitadoOc, permissions: ['MODULO_REQUISITADO_VISUALIZAR_MENU'] },
  { path: '/Cr/moduloExecutado/executado', component: CrfEsin204ContaResultado, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/moduloExecutadoFechamentoMina/executadoFechamentoMina', component: CrfEsin204FechamentoMina, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/Cr/moduloContratado/pedidoMaterial', component: PedidoMaterialIndex, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/Cr/moduloContratado/pedidoServico', component: PedidoServicoIndex, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/Cr/moduloContratado/pedidoSemVinculoCr', component: PedidoSemVinculoCrIndex, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },

  { path: '/Cr/dashboard/crfexecutivesummary', component: CrfExecutiveSummary, permissions: ['MODULO_DASHBOARDS_VISUALIZAR_MENU'] },
  { path: '/Cr/dashboard/crfcurvaeconomica', component: CrfCurvaEconomica, permissions: ['MODULO_DASHBOARDS_VISUALIZAR_MENU'] },
  { path: '/Cr/dashboard/crfbuildup', component: CrfBuildup, permissions: ['MODULO_DASHBOARDS_VISUALIZAR_MENU'] },
  { path: '/Cr/dashboard/crfrelatorioProjectsOverview', component: CrfRelatorioProjectsOverview, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/Cr/dashboard/Crfareaexecutivesummary', component: CrfAreaExecutiveSummary },
  { path: '/Cr/relatorioProjetoCicloAnoPluriAnual', component: CrfRelatorioProjetoCicloAnoPluriAnual, permissions: ['MODULO_RELATORIO_PROJETOS_VISUALIZAR_MENU'] },
  { path: '/Cr/relatorios/relatoriocicloorcamentario', component: CrfRelatorioCicloOrcamentario, permissions: ['MODULO_RELATORIOS_VISUALIZAR_MENU'] },
  { path: '/Cr/relatorios/relatorioCicloOrcamentarioProjeto', component: CrfRelatorioCicloOrcamentarioProjeto },
  { path: '/Cr/relatorios/relatorioProjetoPluriAnual', component: CrfRelatorioCicloOrcamentarioPluriAnual, permissions: ['MODULO_RELATORIOS_VISUALIZAR_MENU'] },
  { path: '/Cr/relatorios/CrfRelatorioProjetoPluriAnualDetalheProjeto', component: CrfRelatorioCicloOrcamentarioProjetoPluriAnual, permissions: ['PROJETO_VISUALIZAR_MENU'] },

  { path: '/Cr/fechamento', component: CrfFechamento, permissions: ['MODULO_FECHAMENTO_VISUALIZAR_MENU'] },
  { path: '/Cr/detalheProjetoFechamento', component: CrfDetalheProjetoFechamento },
  { path: '/Cr/detalheFechamentoProjetoOverView', component: CrfDetalheFechamentoProjetoOverView },
  //#endregion

  //#endregion

  { path: '/contratos', component: Contrato, permissions: ['CONTRATO_GERAL_VISUALIZAR_MENU'] },
  { path: '/contratosEspeciais', component: ContratosEspeciais, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/cicloOrcamentario', component: CicloOrcamentario, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/diretorias', component: Diretoria, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/usuarios', component: Usuario, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/areas', component: Area, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU'] },
  { path: '/departamentos', component: Departamento, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/acronimos/projeto', component: AcronimoProjeto, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/acronimos/pacote', component: AcronimoPacote, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/servicos/prazos', component: ServicoPrazosComponent, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/manutencaoPcmFornecedorFake', component: ManutencaoPcmFornecedor, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/meusDados', component: MeusDados },
  { path: '/moduloOrcado/PlanilhaCapex', component: PlanilhaCapex, permissions: ['MODULO_ORCADO_VISUALIZAR_MENU'], },
  { path: '/moduloOrcado/PlanilhaRfa', component: PlanilhaRfa, permissions: ['MODULO_ORCADO_VISUALIZAR_MENU'], },
  { path: '/moduloOrcado/planilhaOrcadoEconomicoAnoMes', component: PlanilhaOrcadoEconomicoAnoMes, permissions: ['MODULO_ORCADO_VISUALIZAR_MENU'], },
  { path: '/projetos', component: Projeto, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/contratopsc', component: ContratadoPcs, permissions: ['MODULO_CONTRATADO_VISUALIZAR_MENU'] },
  { path: '/contratopcm', component: ContratadoPcm, permissions: ['MODULO_CONTRATADO_VISUALIZAR_MENU'] },
  { path: '/contratadoSemVinculoOi', component: ContratadoSemVinculoOi, permissions: ['MODULO_CONTRATADO_VISUALIZAR_MENU'] },
  { path: '/requisitadoOcordemcompra', component: RequisitadoOc, permissions: ['MODULO_REQUISITADO_VISUALIZAR_MENU'] },
  { path: '/rcrequisicaocompra', component: RequisitadoRc, permissions: ['MODULO_REQUISITADO_VISUALIZAR_MENU'] },
  { path: '/configuracao', component: ConfiguracaoComponent, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/executado', component: Executado, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/relatoriocicloorcamentario', component: RelatorioCicloOrcamentario, permissions: ['MODULO_RELATORIOS_VISUALIZAR_MENU'] },
  { path: '/relatorioCicloOrcamentarioProjeto', component: RelatorioCicloOrcamentarioProjeto },
  { path: '/relatorioProjetoPluriAnual', component: RelatorioCicloOrcamentarioPluriAnual, permissions: ['MODULO_RELATORIOS_VISUALIZAR_MENU'] },
  { path: '/usuarioUltimoAcesso', component: UsuarioUltimoAcesso, permissions: ['MODULO_RELATORIOS_VISUALIZAR_MENU'] },
  { path: '/relatorioProjetoPluriAnualDetalheProjeto', component: RelatorioCicloOrcamentarioProjetoPluriAnual, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/relatorioProjectsOverview', component: RelatorioProjectsOverview, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/executivesummary', component: ExecutiveSummary, permissions: ['MODULO_DASHBOARDS_VISUALIZAR_MENU'] },
  { path: '/curvaeconomica', component: CurvaEconomica, permissions: ['MODULO_DASHBOARDS_VISUALIZAR_MENU'] },
  { path: '/buildup', component: Buildup, permissions: ['MODULO_DASHBOARDS_VISUALIZAR_MENU'] },
  { path: '/projectsOverview', component: ProjectsOverview, permissions: ['MODULO_DASHBOARDS_VISUALIZAR_MENU'] },
  { path: '/definicaoProjeto', component: DefinicaoProjeto, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/definicaoFornecedor', component: DefinicaoFornecedor, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/programa', component: Programa, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/relatorioProjetoPacote', component: RelatorioPacote, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/relatorioProjetosADistribuir', component: ProjetosADistribuir, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/relatorioVerificacaoContratadoAno', component: LogContratadoAno, permissions: ['PROJETO_VISUALIZAR_MENU'] },
  { path: '/relatoriooi', component: RelatorioOi, permissions: ['MODULO_RELATORIOS_OIS_VISUALIZAR_MENU'] },
  { path: '/relatorioProjetoCicloAnoPluriAnual', component: RelatorioProjetoCicloAnoPluriAnual, permissions: ['MODULO_RELATORIO_PROJETOS_VISUALIZAR_MENU'] },
  { path: '/dolarAtual', component: Dolar, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/fechamento', component: Fechamento, permissions: ['MODULO_FECHAMENTO_VISUALIZAR_MENU'] },
  { path: '/detalheProjetoFechamento', component: DetalheProjetoFechamento },
  { path: '/detalheFechamentoProjetoOverView', component: DetalheFechamentoProjetoOverView },
  { path: '/rotinaFechamento', component: RotinaFechamento, permissions: ['MODULO_CONFIGURACAO_VISUALIZAR_MENU'] },
  { path: '/perfilAcesso', component: PerfilAcesso, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/moduloPerfilAcesso', component: ModuloPerfilPermissao, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/definicaoPermissoes', component: DefinicaoPermissao, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/definicaotipomodulo', component: DefinicaoTipoModulo, permissions: ['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU', "b6e77c08-2e7f-476c-9064-26ff3be7be6e"] },
  { path: '/cadastroPermissao', component: CadastroPermissao, permissions: ['b6e77c08-2e7f-476c-9064-26ff3be7be6e'] },
  { path: '/areaexecutivesummary', component: AreaExecutiveSummary },
  { path: '/', component: Home },

];

const AuthRedirect = () => {
  const { instance } = useMsal();
  const loadPermissions = useActions(state => state.permission.loadPermissions);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        // Processa o redirect do MSAL
        const response = await instance.handleRedirectPromise();
        
        if (response && response.account) {
          const account = response.account;
          const scopes = [
            "openid",
            "profile",
            "email",
            "api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user",
          ];

          let tokenResponse: any;
          try {
            tokenResponse = await instance.acquireTokenSilent({ account, scopes });
          } catch (silentError) {
            tokenResponse = await instance.acquireTokenPopup({ scopes });
          }

          if (tokenResponse && tokenResponse.accessToken) {
            const accessToken = tokenResponse.accessToken;

            localStorage.setItem("isAuthenticated", "true");
            localStorage.setItem("idtoken", accessToken);
            localStorage.idtoken = accessToken;
            localStorage.setItem(
              "expiration",
              String(Math.floor(tokenResponse.expiresOn.getTime() / 1000))
            );
            localStorage.setItem("userName", account.username ?? "");

            setAuthorizationToken(accessToken);

            const permissionsResponse: any = await getPermissions();
            const permissions = permissionsResponse.permissoes;
            const idtoken = permissionsResponse.access_token;
            const expiration = permissionsResponse.expires_in;

            loadPermissions(permissions);
            
            if (permissions.length === 1) {
              notification.error('Você não possui acesso ao sistema.');
              localStorage.removeItem("isAuthenticated");
              localStorage.removeItem("idtoken");
              localStorage.removeItem("expiration");
              localStorage.removeItem("userName");
              window.location.href = '/login';
              return;
            }

            localStorage.setItem("idtoken", idtoken);
            localStorage.setItem("expiration", expiration);
            
            setIsAuthenticated(true);
            
            // Força reload completo para garantir que o menu seja renderizado com as permissões corretas
            window.location.href = '/';
          }
        } else {
          // Se não há resposta do redirect, redireciona para login
          window.location.href = '/login';
        }
      } catch (error: any) {
        console.error("Erro ao processar redirect do MSAL:", error);
        window.location.href = '/login';
      }
    };

    handleRedirect();
  }, [instance, loadPermissions]);

  return <div className='divFullScreen'>Processando autenticação...</div>;
}

const App = () => {

  const { instance } = useMsal();


  const header = {
    logo: Logo,
    title: app.name.toUpperCase(),
    onLogout,
    translationConfig: undefined,
  };

  function onLogout() {
    const userLogadoId = localStorage.getItem('userLogadoId');
    if (userLogadoId) {
      registarLogout(userLogadoId);
    }
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('isMRN');
    localStorage.removeItem('idtoken');
    localStorage.removeItem('expiration');
    localStorage.removeItem('userLogadoId');
    localStorage.removeItem('loadPermissions')
    instance.logout();

    storage.setPermissions([]);
    setTimeout(() => {
      setIsAuthenticated(false);
    }, 400)

    const originRedirect = localStorage.getItem('originRedirect');
    if (originRedirect && isNotEmpty(originRedirect)) {
      localStorage.removeItem('originRedirect');
      window.location.href = originRedirect;
    }
  }

  useEffect(() => {
    const jwt = getJwt();
    const exp = getExpirationTime();
    if (jwt === undefined) onLogout();
    else if (exp !== 0 && Date.now() >= exp * 1000) {
      notification.error('Tempo de login expirado.');
      onLogout();
    }

       (function(c: any, l: Document, a: string, r: string, i: any, t: HTMLScriptElement | undefined, y: Element | undefined){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r) as HTMLScriptElement;
        t.async=true;
        t.src="https://www.clarity.ms/tag/ufqfml61cb";
        y=l.getElementsByTagName(r)[0];
        if(y && y.parentNode){
            y.parentNode.insertBefore(t,y);
        }
    })(window, document, "clarity", "script", undefined, undefined, undefined);

  }, []);

  const item = localStorage.getItem('isAuthenticated');
  const userName = getLoggedUsername();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(item ? true : false);
  const MRNWorkspace = () => {
    const menuFullCollapsed = useStore(state => state.ui.menuFullCollapsed);
    const setMenuFullCollapsed = useActions(state => state.ui.setMenuFullCollapsed);

    const masterAreaCollapsed = useStore(state => state.ui.masterAreaCollapsed);
    const setMasterAreaCollapsed = useActions(state => state.ui.setMasterAreaCollapsed);

    const resizeMenuFullCollapsed = () => setTimeout(() => setMenuFullCollapsed(true), 50);
    const resizeMasterAreaCollapsed = () => setTimeout(() => setMasterAreaCollapsed(true), 50);
    const loadPermissions = useActions(state => state.permission.loadPermissions);

    // Carrega permissões quando o componente monta se o usuário estiver autenticado
    // Isso resolve o problema do menu não aparecer no primeiro login SSO
    useEffect(() => {
      const currentPermissions = storage.getPermissions();
      const isAuth = localStorage.getItem('isAuthenticated') === 'true';
      
      // Se está autenticado mas não tem permissões carregadas, carrega as permissões
      if (isAuth && (!currentPermissions || currentPermissions.length === 0)) {
        getPermissions().then((response: any) => {
          if (response && response.permissoes) {
            loadPermissions(response.permissoes);
            // Atualiza o token se necessário
            if (response.access_token) {
              localStorage.setItem("idtoken", response.access_token);
            }
            if (response.expires_in) {
              localStorage.setItem("expiration", response.expires_in);
            }
          }
        }).catch((error: any) => {
          console.error('Erro ao carregar permissões:', error);
        });
      }
    }, [loadPermissions]);

    useEffect(() => {
      !menuFullCollapsed && window.removeEventListener('resize', resizeMenuFullCollapsed);
    }, [menuFullCollapsed]);

    useEffect(() => {
      !masterAreaCollapsed && window.removeEventListener('resize', resizeMasterAreaCollapsed);
    }, [masterAreaCollapsed]);

    menuFullCollapsed && window.addEventListener('resize', resizeMenuFullCollapsed);
    masterAreaCollapsed && window.addEventListener('resize', resizeMasterAreaCollapsed);

    return (
      <RecoilRoot>
        <Workspace
          menu={addMenuTopAreaItem(menu, {
            label: userName,
            icon: 'profile-user_male_circle',
            uri: '/meusDados'
          })}>
          <Switch>
            {createRoutes(routes)}
            <Route path="/" exact component={NotFound} />
          </Switch>
        </Workspace>
      </RecoilRoot>
    );
  };

  return (
    <AuthProvider instance={msalInstance}>
      <Router>
        <Switch>
          <Route
            path="/auth/redirect"
            exact
            render={() => <AuthRedirect />}
          />
          <AppContainer models={models} header={isAuthenticated ? header : {}}>
            <Router>
              <Switch>
                <Route path="/externalRedirect" exact render={() => <ExternalRedirect onAuthenticate={setIsAuthenticated} />} />
                <Route
                  path="/login"
                  exact
                  render={() => <Login isAuthenticated={isAuthenticated} onAuthenticate={setIsAuthenticated} />}
                />
                <PrivateRoute
                  path="/"
                  component={() => <MRNWorkspace />}
                  isAuthenticated={isAuthenticated}
                  redirectTo="/login"
                />
              </Switch>
            </Router>
          </AppContainer>
        </Switch>

      </Router>

    </AuthProvider>

  );
};

export default App;